import { logout } from '../customer-utils';


export const init = () => {
  setActiveLink();

  const logoutBlock = cube.$id('logout-confirmation');
  const logoutButton = cube.$id('logout-button');
  const navigationLogoutConfirmation = cube.$('#dashboard-account-nav .logout-link');

  document.body.on('click', () => toggleConfirmation(logoutBlock, false));

  logoutButton.on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    toggleConfirmation(logoutBlock);
  });

  navigationLogoutConfirmation.on('click', logout);
  logoutBlock.on('click', e => e.stopPropagation());
};


/**
 * Highlight the current page in account navigation
 */
const setActiveLink = () => {
  const navigation = cube.$('.account-navigation');
  const active = navigation.$(`[href='${ document.location.pathname }']`);

  if (active) {
    active.classList.add('active');
    $(active.closest('.panel-collapse')).collapse('show');
  }
};


/**
 * Display / Hide the logout confirmation block by adding / removing a css class
 *
 * @param {HTMLElement} element logout confirmation block
 * @param {Boolean} opened default state of confirmation block true: displayed / false: hide
 */
const toggleConfirmation = (element, opened) => {
  const classes = element.classList;

  if (opened === false || classes.contains('logout-confirmation--open'))
    classes.remove('logout-confirmation--open');
  else
    classes.add('logout-confirmation--open');
};



// WEBPACK FOOTER //
// ./src/customer/account/account-navigation.js